import React, {FunctionComponent, useState} from 'react';

import { ButtonCountdown } from 'components';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, IconButton} from '@cfa/react-components';
import {AsyncStatus} from 'enums';
import {axiosAPI, parseAxiosError} from 'services';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface IEmergencyStopModalProps {
    onHide: () => void,
    show: boolean,
}

export const EmergencyStopModal: FunctionComponent<IEmergencyStopModalProps> = function (props) {
    const { onHide, show } = props;
    const [stopStatus, setStopStatus] = useState(AsyncStatus.Initial);
    const [stopErr, setStopErr] = useState('');

    function tryHide() {
        // Prevent closing the modal if an API call is in progress.
        if (stopStatus !== AsyncStatus.Loading) {
            onHide();
        }
    }

    function activateEmergencyStop() {
        if (stopStatus === AsyncStatus.Loading) return;

        setStopStatus(AsyncStatus.Loading);
        axiosAPI.post('/emergencyStop')
            .then(() => {
                setStopStatus(AsyncStatus.Success);
            }).catch((err) => {
                setStopStatus(AsyncStatus.Error);
                setStopErr(parseAxiosError(err));
            });
        
    }

    return (
        <Modal show={show} onClose={tryHide}>
            <ModalHeader>
                Emergency Stop
            </ModalHeader>
            <ModalBody>
                <div className="emergencyStopModal_iconWrap">
                    <FontAwesomeIcon icon="exclamation-triangle" />
                </div>
                <p className="emergencyStopModal_message">
                    Are you really sure you want to stop the server?!!
                    It will need to be manually reset before it can send updates again.
                </p>
                {stopStatus === AsyncStatus.Error && (
                    <p className="emergencyStopModal_error">
                        Error stopping server: {stopErr}
                    </p>
                )}
                {stopStatus === AsyncStatus.Success && (
                    <p className="emergencyStopModal_success">
                        Server has been stopped.
                    </p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    variant='outlined'
                    onClick={tryHide}
                    disabled={stopStatus === AsyncStatus.Loading}
                >
                    Cancel
                </Button>
                <ButtonCountdown
                    onClick={activateEmergencyStop}
                    disabled={stopStatus === AsyncStatus.Loading || stopStatus === AsyncStatus.Success}
                >
                    {stopStatus === AsyncStatus.Loading && 'Stopping...'}
                    {stopStatus !== AsyncStatus.Loading && 'STOP SERVER'}
                </ButtonCountdown>
            </ModalFooter>
        </Modal>
    );
}